import { m } from 'framer-motion';
// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
// hooks
import { useMockedUser } from 'src/hooks/use-mocked-user';
// auth
import { useAuthContext } from 'src/auth/hooks';
// components
import { varHover } from 'src/components/animate';
import { useSnackbar } from 'src/components/snackbar';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import Iconify from 'src/components/iconify';
import { Button } from '@mui/material';
import { useResponsive } from 'src/hooks/use-responsive';

// ----------------------------------------------------------------------

const OPTIONS = [
  {
    label: 'Applications',
    linkTo: paths.dashboard.order.list,
  },
  {
    label: 'Settings',
    linkTo: paths.settings,
  },
  // {
  //   label: 'Settings',
  //   linkTo: paths.dashboard.user.account,
  // },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const router = useRouter();
  const mdDown = useResponsive('down', 'md');
  const { user, logout, unauthenticated } = useAuthContext();

  const { enqueueSnackbar } = useSnackbar();

  const popover = usePopover();

  const handleLogout = async () => {
    try {
      await logout();
      popover.onClose();
      router.replace('/');
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Unable to logout!', { variant: 'error' });
    }
  };

  const handleClickItem = (path) => {
    popover.onClose();
    router.push(path);
  };

  const goToLogin = () => {
    router.push(paths.auth.firebase.login);
  };

  if (unauthenticated)
    return (
      <IconButton variant="contained" color="primary" onClick={goToLogin}>
        <Iconify icon="solar:user-bold" width={24} />
      </IconButton>
    );

  return (
    <>
      {/* <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        onClick={popover.onOpen}
        sx={{
          width: 40,
          height: 40,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(popover.open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          src={user?.profileImage}
          alt={user?.displayName}
          sx={{
            width: 36,
            height: 36,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
          }}
        />
      </IconButton> */}
      <Button
        component={m.button}
        // whileTap="tap"
        // whileHover="hover"
        // variants={varHover(1.05)}
        onClick={popover.onOpen}
        sx={{
          py: 0.5,
          px: 0.5,
          borderRadius: 1,
          color: '#ffffff',
          '&:hover': {
            backgroundColor: 'transparent', // Keeps background the same on hover
            boxShadow: 'none', // Prevents any shadow on hover
          },
        }}
        endIcon={!mdDown && <Iconify icon="iconamoon:arrow-down-2-light" width={16} />}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <Avatar
            src={user?.profileImage}
            alt={user?.displayName}
            sx={{
              borderRadius: '8px',
              width: 40,
              height: 40,
            }}
          />
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <Typography variant="subtitle2" noWrap>
              {user?.displayName || 'User'}
            </Typography>
          </Box>
        </Stack>
      </Button>

      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        sx={{ width: { xs: 180, md: 260 }, p: 0 }}
      >
        <Stack
          direction="row"
          alignItems="center"
          sx={{
            p: 1,
          }}
        >
          <Avatar
            src={user?.profileImage}
            alt={user?.displayName}
            sx={{
              borderRadius: '8px',
              width: 48,
              height: 48,
            }}
          />
          <Box sx={{ p: 2, pb: 1.5 }}>
            <Typography variant="subtitle2" noWrap>
              {user?.displayName}
            </Typography>
            {!mdDown && (
              <Typography variant="caption" sx={{ color: 'text.secondary' }} noWrap>
                {user?.email}
              </Typography>
            )}
          </Box>
        </Stack>
        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem
          onClick={handleLogout}
          sx={{ m: 1, fontWeight: 'fontWeightBold', color: 'error.main' }}
        >
          Sign Out
        </MenuItem>
      </CustomPopover>
    </>
  );
}
